import { render, staticRenderFns } from "./QueueCard.vue?vue&type=template&id=435c151f&scoped=true"
import script from "./QueueCard.vue?vue&type=script&lang=js"
export * from "./QueueCard.vue?vue&type=script&lang=js"
import style0 from "./QueueCard.vue?vue&type=style&index=0&id=435c151f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435c151f",
  null
  
)

export default component.exports